<template>
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <slot />
    </div>
</template>
